import React, { useState } from 'react';
import { Tabs, Button } from '@roo/roo';
import styled, { createGlobalStyle } from 'styled-components';
import Cls from 'classnames';
import WaterMark from 'watermark-component-for-react';
import Header from '@components/HeaderWithoutMenu';
import { getWaterMarkStr } from '@utils/config';
import { useUserData } from '@components/UserData';
import { useSimpleContext as useSimpleDetailContext } from '@components/Review/Detail';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@hooks/query';
import { useSimpleContext } from '../_context';
import { Footer } from './Footer';
import { step_imgs, step_imgs_h } from '../../apply/_components/Layout';
import Innovate from '../../preview/innovate';
import Scientist from '../../preview/scientist';
import Catalogue from '../../preview/_components/catalogue/catalogue';

const { Pane: TabPane } = Tabs;
const GlobalStyle = createGlobalStyle`
  body{
    .roo-btn.roo-btn-primary {
    background-color: #222;
    border-color: #222;
    }
    .roo-btn {
    border-radius: 0;
    }
    .cont{
      height: calc(100vh - 140px);
      overflow: scroll;
    }
  }
`;

const Style = createGlobalStyle`
  .body {
    .t-tip-toast {
      padding-top: 6px;
      .has-tip {
      }
    }
  }
`;
const Root = styled.div`
  background-color: #e1e2e6;
  border-radius: 8px;
  &.viewType {
    user-select: none;
    .footer {
      margin-top: 24px;
    }
    background-color: #fff;
    .wrap {
      .body {
        overflow-x: auto;
        min-height: calc(100vh - 170px);
        .cont {
          .apply {
            min-width: 768px;
            .form-patch {
              margin: 8px 0 0 0;
              width: 100%;
              padding: 32px;
            }
          }
        }
      }
    }
    .help-block {
      /* display: none; */
    }
    .has-error .select-input-wrapper .roo-input,
    .has-error .select-input-wrapper .form-control,
    .has-error .roo-input,
    .has-error .form-control {
      border-color: #e9eaf2 !important;
    }
    .patch-tips,
    .t-info,
    p.info {
      display: none;
      visibility: hidden;
    }
    .hid-view {
      display: none;
      visibility: hidden;
    }
  }
  .wrap {
    position: relative;
    margin: 70px -2px 0px;
  }

  .upload {
    background: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 2px;
    height: 94px;
    text-align: center;
    font-size: 14px;
    color: #666666;
    padding-top: 20px;

    > p {
      margin-top: 8px;

      &:last-child {
        font-size: 12px;
        color: #999999;
      }
    }
  }
  .form-title {
    .sub-title {
      display: block;
      margin-top: 8px;
      margin-left: 0;
      color: #222222;
    }
    .sub-title-inline {
      //display: block;
      //margin-top: 8px;
      margin-left: 8px;
      color: #222222;
    }
  }
  .t-info {
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 14px;
    text-align: left;
    margin-bottom: 24px;
    display: inline-block;
    i {
      margin-right: 4px;
      position: relative;
      top: -1px;
    }
  }
  .roo-input-number {
    input {
      width: 214px;
      text-align: left;
      margin-left: 10px;
    }
  }

  .patch-tips {
    width: 634px;
    margin: auto;
    padding-left: 44px;
    font-size: 16px;
    color: #222222;
    font-weight: 500;

    .info {
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 14px;
      text-align: left;
      margin-top: 8px;
    }
  }
  .f-recommend {
    .roo-input-required {
      position: relative;
      left: -13px;
    }
  }
  .field-required-label-h {
    &::before {
      content: '*';
      color: red;
      margin-right: 6px;
    }
  }
  .head {
    .over-tip {
      font-size: 14px;
    }
  }
  .roo-upload-list-item {
    color: #222;
  }
  .form-btn-x {
    position: fixed;
    width: calc(100vw - 244px);
    background: #ffffff;
    box-shadow: 0 -2px 6px 0 rgb(0 0 0 / 6%);
    margin-bottom: 0;
    margin-left: 0;
    bottom: 0;
    padding: 10px 0;
  }
  .wrap {
    .apply-tabs {
      .roo-tabs-nav > li > a > span {
        font-size: 20px;
      }
      .tab-item.active {
        font-weight: 500;
      }
    }
  }
`;
export const tipsTitle = {
  scientist: '青山科技奖',
  innovate: '“科创中国”美团青山环保科技创新示范项目',
};

export const Layout = function (props) {
  const query = useQuery();
  const history = useHistory();
  const { state } = useSimpleContext((t) => [
    t.step,
    t.formType,
    t.isViewType,
    t.hasSubmit,
    t.onSubmit,
    t.hasSave,
    t.values,
    t.innovate,
    t.scientist,
  ]);
  const { state: detailState } = useSimpleDetailContext((t) => t.hasReview);

  const [obFlag, setObFlag] = useState(0);
  const startOb = () => {
    setObFlag(obFlag + 1);
  };

  const queryFormType = query.get('projectType');
  const groupId = query.get('groupId');
  // const config = {
  //   innovate: {
  //     title: '"科创中国"美团青山环保科技创新示范项目',
  //     // 数组首行加空字符串的目的是为了保持和step统一，step从1开始，数组下标从0开始
  //     // 这样的空字符串太令人困惑了
  //     // 由于牵扯太多，暂时就不修改了，留个注释，以便后来的人看得懂
  //     menus: ['', '附加信息', '申报信息'],
  //   },
  //   scientist: {
  //     title: '青山科技奖',
  //     menus: ['', '基础信息', '科研信息', '申报信息'],
  //   },
  // };

  const { mtUid } = useUserData(); // phone 字段已经删除
  const [tabName, setTabName] = useState('project');
  return (
    <Root className={Cls('innovate', props.className)}>
      <Header plate={state.isViewType ? '评审平台' : '项目申报'} />
      <div className="wrap">
        <Button
          type="hollow"
          style={{
            position: 'absolute',
            right: '10px',
            top: '4px',
            padding: '10px 30px',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '20px',
            zIndex: '999',
          }}
          onClick={() => {
            history.replace({
              pathname: '/review/projectList',
              search: `groupId=${groupId}`,
            });
          }}
        >
          返回项目列表
        </Button>
        <WaterMark content={getWaterMarkStr(mtUid)} width={400}>
          <Tabs type="line" className={`tab--${tabName} apply-tabs`} onTabClick={setTabName}>
            <TabPane label="项目申报信息" name="project">
              <div className="body">
                <div className="cont">
                  <div className="preview-container">
                    <Catalogue startObserver={obFlag} />

                    {
                      queryFormType === '1' ? (
                        <Scientist startOb={startOb} projectNo={props.projectNo} />
                      ) : (
                        <Innovate startOb={startOb} projectNo={props.projectNo} />
                      )
                    }
                  </div>
                  <Style />
                  <div id="test-tip" />
                  <Footer />
                </div>
              </div>
            </TabPane>
            {detailState.hasReview && (
              <TabPane label="评审信息" name="review">
                {props.children}
              </TabPane>
            )}
          </Tabs>
        </WaterMark>
      </div>
      <GlobalStyle />
    </Root>
  );
};
